import AdvisersSearchResultsHtml from '../advisers/templates/advisers.search.results.html';

export function ReturnLoanCarEventCtrl (
  $q, 
  $rootScope, 
  $scope, 
  $state,
  $timeout, 
  $translate, 
  $uibModalInstance, 
  confirm,
  customer,
  event,
  invoice,
  loan,
  loan_vehicle,
  LoanCarEvents,
  messages,
  serviceAdviserBefore,
  serviceAdviserReturn,
  sessionObjAPI, 
  states,
  status,
  streamSearch,
  workshopAPI
) {

  $scope.loanStatusTypes = status;
  $scope.loan_vehicle = loan_vehicle;
  $scope.states = states;
  $scope.loan_car = loan;
  $scope.invoice = invoice;
  $scope.event = event;
  $scope.customer = customer;
  $scope.company = sessionObjAPI.company();
  if ($scope.company.company_variable_fields.plate_number_name) {
    $scope.regoLabel = $scope.company.company_variable_fields.plate_number_name;
  }
  else {
    $scope.regoLabel = sessionObjAPI.countrySettings().rego_label;
  }
  ;
  $scope.LoanCarEvents = new LoanCarEvents($scope.loan_car);
  $scope.serviceAdviserBefore = serviceAdviserBefore;
  $scope.serviceAdviserReturn = serviceAdviserReturn;
  $scope.returnLoan = function () {
    $scope.LoanCarEvents.save().then(function () {
      workshopAPI.get('/loan_car/return_loan_car', $scope.LoanCarEvents.loanCar.id);
    }).then(function (loan) {
      $uibModalInstance.close();
      messages.show($translate.instant('LOAN_CAR_SPACE.LOAN_CAR_RETURNED'), 'success');
    }, function (err) {
      return $q.reject(err);
    });
  };
  $scope.serviceAdviserSearch = {
    templateUrl: AdvisersSearchResultsHtml,
    list: [],
    value: {
      id: serviceAdviserReturn ? $scope.serviceAdviserReturn.id : '',
      display_name: serviceAdviserReturn ? $scope.serviceAdviserReturn.display_name : '',
    },
    query: function (value) {
      return workshopAPI.get('/service_advisers/list', [ value, 0, '*' ]);
    },
    select: function (adviser) {
      $scope.serviceAdviserReturn.id = adviser.id;
      $scope.serviceAdviserReturn.display_name = adviser.display_name;
      $scope.loan_car.confirmed_by_return = $scope.serviceAdviserReturn.id;
    },
    format: function (adviser) {
      return adviser ? adviser.display_name : '';
    }
  };
}
